import { React } from "react";

const TabHeader = (props) => {
  return (
    <div className="tab-header">
      <h1 className="headline-3">{props.tabHeaderTitle}</h1>
      {props.tabHeaderText ? (
        <p className="tab-header-text body-text">{props.tabHeaderText}</p>
      ) : null}
      {props.tabHeaderText2 ? (
        <p className="tab-header-text body-text">{props.tabHeaderText2}</p>
      ) : null}
    </div>
  );
};

export default TabHeader;
